import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CasoDeUsoBean } from 'src/app/shared/casosDeUso';
import { HucuService } from '../hucu.service';
import swal from 'sweetalert2';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { FlujoAlternoBean } from 'src/app/shared/flujo_alterno';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectChange, MatSelect } from '@angular/material/select';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { ProductosSalidaBean } from 'src/app/shared/productosSalida';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { NgFor, NgIf } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
    selector: 'app-modal-cu',
    templateUrl: './modal-cu.component.html',
    styleUrls: ['./modal-cu.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSelect, NgFor, MatOption, MatButton, NgIf, MatDividerModule, NgxMatSelectSearchModule, MatSuffix]
})
export class ModalCuComponent {
  objetoCasosDeUso: CasoDeUsoBean;
  @Input() id_proyecto: string;
  @Input() datosCu: any;
  @Input() dialogRef: MatDialogRef<ModalCuComponent>;
  
  listaCu: Array<CasoDeUsoBean>;
  flujoAlterno:FlujoAlternoBean = new FlujoAlternoBean();
  productosSalida: ProductosSalidaBean = new ProductosSalidaBean();
  listaCasosUso:CasoDeUsoBean[] = [];
  flujosAlterno:FlujoAlternoBean[] = [];
  listProductoSalida: ProductosSalidaBean[] = [];
  esEditar: boolean;
  casoUsoGroup: FormGroup;
  listaDEmpleados: Array<Empleado>;
  empleadoResponsable: number = null;
  formCliente = new FormControl();


  constructor(private hucuService: HucuService, private serviceProy: ProyectosService,
    @Inject(MAT_DIALOG_DATA) public data: any, private msg: Msg, private formbuilder: FormBuilder
  ) { }

  ngOnInit() {
    if (this.datosCu != null) {
      this.objetoCasosDeUso = this.datosCu;
      this.consultaCasosDUso(this.datosCu.id);
      this.consultaProductosSalida();
      this.esEditar=true;
    } else {
      this.objetoCasosDeUso = new CasoDeUsoBean();
      this.objetoCasosDeUso.id_proyecto = this.id_proyecto;
      this.consultaCasosDeUso();
      this.consultaFluioAlterno();
      
    }
    this.consultaEmpleados();
    this.inicializarFormulario();
  }
  
  inicializarFormulario(){
    this.casoUsoGroup = this.formbuilder.group({
      tituloCtrl: ['' , Validators.required],
      descripcionCtrl: ['', Validators.required],
      actoresCtrl: [''],
      precondicionesCtrl: ['', Validators.required],
      flujoPrimarioCtrl: ['', Validators.required],
      posCondicionesCtrl: [''],
      reglasNegocioCtrl: ['', Validators.required],
      premisasCtrl: [''],
      responsableCtrl: [''],
    });
    this.formCliente.valueChanges.subscribe(() => {
      this.filtraCliente();
    });
}



guardarCu() {
  if(this.flujoAlterno.flujo_alterno != undefined  && this.flujoAlterno.flujo_alterno != null && 
    this.flujoAlterno.descripcion != undefined  && this.flujoAlterno.descripcion != null){
      swal.fire({
        title: 'Mensaje',
        text: "Debe de Agregar su flujo alterno a la lista"
      });
    }else if(this.productosSalida.descripcion != undefined && this.productosSalida.descripcion != null && this.productosSalida.descripcion != ""){
      swal.fire({
        title: 'Mensaje',
        text: "Debe de Agregar su Producto a la lista"
      });
    }else{
    this.objetoCasosDeUso.flujosAlternos = this.flujosAlterno;
    this.objetoCasosDeUso.productosSalida = this.listProductoSalida;
  this.hucuService.guardarCu(this.objetoCasosDeUso).subscribe(
    (respuesta) => {
      swal.fire({
        text: 'Caso de Uso registrado exitosamente',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        icon: 'success',

      }).then((result) => {
        this.dialogRef.close(true);
      });
    });
  }
}

agregarFlujo() {
  if(this.flujoAlterno.flujo_alterno_anterior != undefined || this.flujoAlterno.flujo_alterno_anterior != null){
    this.flujoAlterno = new FlujoAlternoBean();
  }else{
    this.flujoAlterno.id_principal = this.objetoCasosDeUso.id ?  this.objetoCasosDeUso.id : 0;
    if(!this.flujosAlterno.find(flujo => flujo.flujo_alterno === this.flujoAlterno.flujo_alterno)){
      this.flujosAlterno.push(this.flujoAlterno);
      this.flujoAlterno = new FlujoAlternoBean();
    }else{
      this.msg.errorCall("Un flujo de la lista ya tiene asignado el caso de uso",null,null)
    }
    
  }
}

editarFlujo(flujos: FlujoAlternoBean){
  this.flujoAlterno = flujos;
  this.flujoAlterno.flujo_alterno_anterior = flujos.id_principal;
}

agregarProductoSalida() {
  if(this.productosSalida.producto_salida_anterior != undefined || this.productosSalida.producto_salida_anterior != null){
    this.productosSalida = new ProductosSalidaBean();
  }else{
    const productosExcluyendoActual = this.listProductoSalida.filter(p => p !== this.productosSalida);  
    if (productosExcluyendoActual.some(p => p.descripcion === this.productosSalida.descripcion)){
      this.msg.errorCall("Ya tienes un producto con la misma descripción",null,null)
      this.productosSalida.descripcion = '';
    }else{
      this.listProductoSalida.push(this.productosSalida);
      this.productosSalida = new ProductosSalidaBean();
    }
  }
}


editarProductoSalida(producto: ProductosSalidaBean){
  this.productosSalida = producto;
  this.productosSalida.producto_salida_anterior = producto.descripcion;
}


consultaCasosDUso(id: number) {
  this.hucuService.consultaCu(id).subscribe(res => {
    this.listaCu = res.list;
    if (this.listaCu.length > 0) {
      this.objetoCasosDeUso = this.listaCu[0];
      this.consultaCasosDeUso();
      this.consultaFluioAlterno();
    }
  });
}

consultaCasosDeUso() {
  this.hucuService.consultaCuPorProyecto(this.objetoCasosDeUso).subscribe(res => {
    if (res.length > 0) {
      this.listaCasosUso = res;
    }
  });
}

consultaFluioAlterno() {
  this.hucuService.consultaFlujosAlternos(this.objetoCasosDeUso).subscribe(res => {
    if (res.length > 0) {
      this.flujosAlterno = res;
    }
  });
}

consultaEmpleados() {
  this.serviceProy.consultaEmpleados().subscribe(res => {
    this.listaDEmpleados = res.list;
    
  });
}

consultaProductosSalida(){
  this.hucuService.consultaProductosSalida(this.objetoCasosDeUso).subscribe(res => {
    if (res.length > 0) {
      this.listProductoSalida = res;
    }
  });
}
clearNombreCli() {
  this.empleadoResponsable = null;
  this.casoUsoGroup.get('responsableCtrl').setValue('');
  this.consultaEmpleados();
}

filtraCliente() {
  let search = this.formCliente.value;
  if (!search && this.listaDEmpleados) {
    return;
  } else {
    search = search.toLowerCase();
  }
  this.listaDEmpleados = this.listaDEmpleados.filter(cliente => cliente.persona.nombreCompleto.toLowerCase().includes(search));
}

}